import React from 'react'
import styles from './styles.module.css'
import Container from '@packages/justo-parts/lib/components/Container'
import { useTranslation } from 'react-i18next'

export default function Demo(props) {
  const {t} = useTranslation('website', {keyPrefix: 'layout.demo'})
  return (
    <div className={styles.container}>
      <Container>
        <div className={styles.inner}>
          <div className={styles.description}>{t('labelDescription')}</div>
        </div>
      </Container>
    </div>
  )
}
